import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import './Dashboard.css';
import enhance from './Dashboard.enhancer.js';
import CompanyDashboard from './company/CompanyDashboard';
import InfluencerDashboard from './influencer/InfluencerDashboard';

class Dashboard extends Component {
  componentWillMount() {
    const pp = 5;
  }

  render() {
    const { auth, profile, dealList, campaignList, classes } = this.props;
    if (!auth.uid) return <Redirect to="/signin" />;

    return (
      <div className={classes.dashboard}>
        {profile.isLoaded && profile.isCompany && (
          <CompanyDashboard dealList={dealList} campaignList={campaignList} />
        )}
        {profile.isLoaded && !profile.isCompany && (
          <InfluencerDashboard dealList={dealList} />
        )}
      </div>
    );
  }
}

export default enhance(Dashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js